import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
// import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
})
export class ProfileMenuComponent implements OnInit {

  @Input() menu_type: any = 'default';
  constructor(public popover: PopoverController, public router: Router, 
    public alertCtrl: AlertController, private storage: Storage) { }

  ngOnInit() {}

  async logout() {
    let alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Do you really want to logout?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            localStorage.clear();
            this.storage.clear();
            this.popover.dismiss();
            this.storage.remove('survey_info');
            location.href = '/';
          }
        }
      ]
    })
    await alert.present();
  }

  change_route(route:any) {
    if(route == '/dashboard' && localStorage['vendorId'])
      route = '/sites';
    this.popover.dismiss();
    this.router.navigate([route]);
  }

}
